import { useMemo } from "react";
import { CAMPAIGNS } from "../lib/data";

// O(1) lookup of campaign by slug, plus its index and the next campaign.
export const useCampaignBySlug = (slug) => {
  return useMemo(() => {
    const index = CAMPAIGNS.findIndex((c) => c.slug === slug);
    if (index < 0)
      return { campaign: null, index: -1, next: null, total: CAMPAIGNS.length };
    const campaign = CAMPAIGNS[index];
    const next = CAMPAIGNS[(index + 1) % CAMPAIGNS.length];
    return { campaign, index, next, total: CAMPAIGNS.length };
  }, [slug]);
};
